import { Component, ViewChild, ElementRef, AfterViewInit, HostListener } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { MatDialog } from '@angular/material/dialog';
import { MatMenuTrigger } from '@angular/material/menu';
import { FormGroup } from '@angular/forms';
import { NavController, MenuController } from '@ionic/angular';
import { Materials } from './material/materialOptions.interface';
import { Message } from '../../service/dialog/message.interface';
import { Utils } from '../../service/utils';
import { throwError as observableThrowError, Observable, Subscription } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import * as $ from 'jquery';
import _ from 'lodash';
import { Start } from './start/start'; // mobile only page
import { Summary } from './summary/summary'; // mobile only page
import { Material } from './material/material';
import { Endmill } from './endmill/endmill';
import { Machine } from './machine/machine';
import { Operation } from './operation/operation';
import { Parameters } from './parameters/parameters';
import { Recommendations } from './recommendations/recommendations';
import { LoginProvider } from '../login/login.service';
import { CacheService } from 'ionic-cache';
import {
  Cutter_,
  Hem_,
  Material_,
  ToolContainer,
  CurrentToolPath,
  Parameters_,
  Machine_,
  Recommendation_,
  ParametersAndRecommendations
} from '../../service/formulas/objects';
import { Formulas } from '../../service/formulas/formulas';
import { CommonService } from '../../service/common.service';
import { ImageConstants } from '../../service/image-constants';
import { Deeplinks } from '@ionic-native/deeplinks/ngx';
import { Hardness } from './hardness.model';
import { ServiceProvider } from '../../service/provider.interface';
import { ToolProvider } from './tool.service';
import { compress, decompress } from 'compress-json';

declare var navigator;

interface EndmillParams {
  brand: string;
  sku: string;
}

@Component({
  selector: 'page-tool',
  templateUrl: 'tool.html',
  providers: [LoginProvider, ToolProvider],
  styleUrls: ['tool.scss']
})
export class ToolPage extends ServiceProvider implements AfterViewInit {
  private subscription: Subscription;
  public sumarraySelected: boolean = false;
  public iputSpecs: boolean = true;
  private windowsDimensions: object = undefined;
  private workHolding: number = 100;
  private maxRPM: number = null;
  private maxIPM: number = null;
  private insideCornerValue: number = null;
  public loggedIn: boolean = false;
  endmillParams: EndmillParams;
  public savedParamsAndRecs: { [toolId: number]: ParametersAndRecommendations[] };
  public allParamsAndRecsCached: boolean = false;
  private toolpop: {
    machine: boolean;
    material: boolean;
    operations: boolean;
    tool: boolean;
  };
  mobileMenuOpened: boolean = false;
  tool: FormGroup;
  tabs: Array<tabsContent>;
  isApp: boolean;
  isOnline: boolean;
  isLoading: boolean;
  materials: Materials;
  errorMessage: string;
  selectedIndex: number;
  edp: object;
  hem: Hem_;
  children: Array<string>;
  settingsHolder: ToolContainer = new ToolContainer();
  oldSettingsHolder: ToolContainer = new ToolContainer();
  pathDiameter: number;
  searchingForTool: boolean = false;
  private loginResponse: any;
  private trackData: boolean = false;
  private toolVersion: number;

  operations: object = {
    toolPath: <CurrentToolPath>{}
  };

  parameters: object = {
    rdoc: 0,
    adoc: 0,
    stickout: 0,
    stickoutPercentage: 0,
    adocMax: 1.5 //default
  };

  recommendations: Recommendation_;
  material: object = {};
  adocMax: number = 1.5; //default
  private newHolder: ToolContainer;

  @ViewChild('gridholderTable', { static: false }) gridholderTable: ElementRef;
  @ViewChild('tabHolder', { static: false }) tabHolder: ElementRef;
  @ViewChild(MatMenuTrigger, { static: false }) accountMenu: MatMenuTrigger;

  @HostListener('window:resize', ['$event'])
  onWindowResize() {
    this.onResize();
  }

  constructor(
    public navCtrl: NavController,
    public menu: MenuController,
    public utils: Utils,
    public dialog: MatDialog,
    private commonService: CommonService,
    private formulas: Formulas,
    public cache: CacheService,
    private loginProvider: LoginProvider,
    private toolProvider: ToolProvider,
    public imageConstants: ImageConstants,
    private deeplinks: Deeplinks,
    private http: HttpClient
  ) {
    super();
    this.savedParamsAndRecs = {};

    this.materials = {
      all: [],
      conditions: [],
      materials: [],
      subgroups: []
    };

    this.endmillParams = {
      sku: '',
      brand: ''
    };

    this.cache
      .getItem('allParamsAndRecsCached')
      .then(data => {
        this.allParamsAndRecsCached = data;
      })
      .catch(err => console.log(err));

    this.cache
      .getItem('loginInfo')
      .then(data => {
        this.loginResponse = data;
        // Set default cache TTL so when we update the params and recs cache it expires when the token does
        this.cache.setDefaultTTL(this.loginResponse.expires_in);

        // The AuthenticationProperties can only return a dictionary of <string, string>
        // trackData is a bool in the DB but will be returned as the string value because of this
        this.trackData = this.loginResponse.trackData === 'true';

        this.checkToolVersion();
      })
      .catch(err => console.log(err));

    this.cache
      .getItem('materials')
      .then(data => {
        let matTab = _.find(this.tabs, { label: 'Material' });
        this.materials = data;
        matTab.input = this.materials;
      })
      .catch(err => console.log(err));

    this.cache
      .getItem('toolVersion')
      .then(data => {
        this.toolVersion = data;
      })
      .catch(err => this.loginProvider.logOut());

    this.toolpop = {
      machine: false,
      material: false,
      operations: false,
      tool: false
    };
    this.newHolder = new ToolContainer();
    this.children = !this.utils.isApp()
      ? ['tool', 'parameters', 'material', 'operation', 'machine', 'recommendations']
      : ['start', 'tool', 'parameters', 'material', 'operation', 'machine', 'recommendations', 'summary']; // all the kids, default
    this.selectedIndex = 0;
    this.menu.enable(false);
    this.onResize();
    this.isOnline = navigator.onLine || navigator.connection.type != 'none' ? true : false;

    if (this.isApp) {
      this.cache.getItem('windowsDimensions').then(windowsDimensions => {
        this.windowsDimensions = windowsDimensions;
      });

      $('.scroll-content').css({
        width: '100%'
      });
    }

    this.settingsHolder.machine = {
      spindle: 'CV40',
      holder: '',
      maxRPM: null,
      maxIPM: null,
      fixtureBar: 100,
      holderAdjustment: [],
      spindleAdjustment: []
    };

    this.tabs = [
      new tabsContent('Start Project', Start, {
        startClicked: $event => this.startClicked($event)
      }),
      new tabsContent(
        'Tool',
        Endmill,
        {
          edpChange: $event => {
            if (typeof $event === 'string') {
              // if it returns as a string, then we know its an error, else its an object

              if (_.trim($event).length > 1) {
                let message: Message = {
                  title: 'Invalid',
                  message: $event + ' is not a valid EDP number.'
                };
                this.utils.openDialog(message, 'error');
              }
              // notify parameters
            } else {
              // so if edp is changed, call updateHolder
              this.edp = this.formulas.defineEndmillFeatures(<Cutter_>$event); //casting object to a Cutter object
              this.updateHolder(<Cutter_>this.edp, 'cutter', 'tool');
            }

            // if there is a material chosen already, we want to check if its compatible with the tool
          },
          startClicked: $event => this.startClicked($event)
        },
        this.endmillParams
      ),
      new tabsContent(
        'Material',
        Material,
        {
          hardnessChange: $event => this.updateHolder(<Hardness>$event, 'hardness', 'material'),
          materialChange: $event => this.updateHolder(<Material_>$event, 'material', 'material')
        },
        this.materials
      ),
      new tabsContent('Operations', Operation, {
        operationTypeChange: $event => this.updateHolder(<string>$event, 'currentOpertaionType', 'operation'),
        toolPathChange: $event => this.updateHolder(<string>$event, 'currenttoolpath', 'operation'),
        strategyChange: $event => this.updateHolder(<string>$event, 'currentStrategy', 'operation')
      }),
      new tabsContent('Machine', Machine, {
        machineChange: $event => {
          this.updateHolder(<Machine_>$event, 'machine', 'machine');
        }
      }),
      new tabsContent(
        'Parameters',
        Parameters,
        {
          parameterChange: $event => this.updateHolder(<Parameters_>$event, 'parameters', 'parameters'),
          parameterChangeWithSpecificChild: $event => {
            this.updateHolder(<object>$event, 'parameterChangeWithSpecificChild', 'parameters');
          },
          resetMaterial: $event => {
            this.resetMateral(); //yeah, update all
          },
          resetTool: $event => {
            this.resetTool(); //reset the tool, reset the endmill
          },
          invalidEndmillMessage: $event => {
            //
          }
        },
        this.parameters
      ), // setting up the emitter, what to do when data is returned back from child component, arDocChange is a Emitter, we are asking to have it listen to arDocChange
      new tabsContent('Recommendations', Recommendations, {
        recommendationChange: $event => {
          this.updateHolder(<object>$event, 'recommendations', 'recommendations');
        },
        recommendationChangeWithChild: $event => {
          this.updateHolder(<object>$event, 'recommendationChangeWithChild', 'recommendations');
        },
        aggressiveWarning: $event => {
          this.updateHolder(<object>$event, 'aggressiveWarning', 'recommendations');
        }
      }),
      new tabsContent('Summary', Summary, {
        goTab: $event => this.startClicked($event),
        resetAll: () => {
          this.resetAll();
        }
      })
    ];

    if (!this.utils.isApp()) {
      this.tabs.splice(0, 1); // remove start page, cause desktop does not have start page
      this.tabs.splice(this.tabs.length - 1, 1); // remove summary page, cause desktop does not have summary page
    } else {
      this.setTabholder();
    }
  }
  // autocomplete panel detection, there is no correct way to detect that currently with material2

  private onResize = () => {
    this.isApp = this.utils.isApp();
  };

  public toolReset = () => {
    let message: Message = {
      title: 'Reset',
      message: 'Are you sure you want to reset your selections?'
    };
    this.utils.openDialog(message, 'confirm', () => {
      // ok
      this.resetAll();
    });
  };

  public helpTip = () => {
    if (this.isApp) {
      this.utils.apptentiveEngage('help & tips');
    }
  };

  public logOut = () => {
    let message: Message = {
      title: 'Logout',
      message: 'Are you sure you want to logout?'
    };
    this.utils.openDialog(message, 'confirm', () => {
      // ok
      this.loginProvider.logOut();
    });
  };

  public logUserData = (location: string) => {
    if (
      this.trackData &&
      (location === 'session end' ||
        (this.settingsHolder.material &&
          this.settingsHolder.tool &&
          this.settingsHolder.tool.materialIds.indexOf(this.settingsHolder.material.id) > -1))
    ) {
      this.toolProvider.logUserData(location, this.settingsHolder, this.recommendations).subscribe(response => {
        console.log(response);
      });
    }
  };

  public promptWorkOffline = () => {
    let message: Message = {
      title: 'Work Offline',
      message:
        'Are you sure that you want to start the process to allow for offline access? It will take 15-20 minutes to complete and you will need to have internet connection (wifi preferred).<br/>' +
        'If you are not on wifi then this may result in high mobile data usage to complete. Data rates may apply.'
    };
    this.utils.openDialog(message, 'confirm', () => {
      this.cacheParamsAndRecsForOfflineMode();
    });
  };

  public cacheParamsAndRecsForOfflineMode = async () => {
    let message: Message = {
      title: 'Work Offline',
      message: 'Current Progress',
      data: this.toolProvider
    };

    this.utils.openDialog(message, 'workOffline', results => {
      this.allParamsAndRecsCached = results.gotAllData;
      this.cache.saveItem('allParamsAndRecsCached', results.gotAllData);
    });
  };

  resetMateral = () => {
    this.settingsHolder.material = undefined;
    this.settingsHolder.displayParamsAndRecs = false;
    this.settingsHolder.mapModeTwoValues = undefined;
    this.commonService.notifyOther({
      option: 'resetMaterial',
      value: this.settingsHolder,
      resetMaterialMessage: true
    }); // resetting all, all will listen for a "RESET"
    this.selectedIndex = 2;
  };

  resetTool = () => {
    this.settingsHolder.tool = undefined;
    this.commonService.notifyOther({
      option: 'resetTool',
      value: this.settingsHolder
    }); // resetting Tool
  };

  private checkToolVersion = () => {
    if(this.isOnline) { 
      this.loginProvider
      .getLatestToolVersion(this.loginResponse)
      .toPromise().then(version =>  
        {
          if(version !== this.toolVersion) {
            this.loginProvider.logOut();
          }
        }
      ).catch(err => console.log(err));
    }
  }

  ngAfterViewInit() {
    this.cache.getItem('loginInfo').then(data => {
      this.loggedIn = true;
      if (this.isApp) {
        this.activateDeepLink();
      }
    });

    this.subscription = this.commonService.notifyObservable$.subscribe(res => {
      if (res.option === 'logout') {
        this.subscription.unsubscribe();
      }
      if (res.option === 'deepLinkSearchFinish') {
        this.searchingForTool = false;
      }
      if (res.option === 'logdata') {
        this.logUserData(res.value.logLocation);
      }
      if (res.option === 'updateRecommendationsDataLog') {
        this.recommendations = res.value;
      }
      if (res.option === 'recommendationsGeneratedForLoggingData') {
        setTimeout(() => {
          if (
            this.settingsHolder.tool &&
            this.recommendations &&
            this.settingsHolder.currenttoolpath && this.settingsHolder.currenttoolpath.operationName &&
            (!this.settingsHolder.hasStrategyOption || !!this.settingsHolder.currentStrategy) &&
            this.settingsHolder.material &&
            this.settingsHolder.machine &&
            this.settingsHolder.machine.holder &&
            this.settingsHolder.machine.spindle
          ) {
            this.logUserData('recommendations generated');
          }
        });
      }
      if (res.option === 'mapModeChanged') {
        this.settingsHolder.mapMode = res.value.mapMode;
      }
      if (res.option === 'clearToolPath') {
        this.settingsHolder.mapMode = 0;
        this.settingsHolder.currentStrategy = null;
        this.settingsHolder.currenttoolpath = res.value;
      }
      if (res.option === 'checkToGetParamsAndRecs') {
        if (
          this.settingsHolder.tool &&
          this.settingsHolder.currenttoolpath &&
          (this.settingsHolder.hasStrategyOption ? !!this.settingsHolder.currentStrategy : true) &&
          this.settingsHolder.hardness &&
          this.settingsHolder.material &&
          this.settingsHolder.mapMode === 2 &&
          this.settingsHolder.tool.materialIds.includes(this.settingsHolder.material.id)
        ) {
          this.cache
            .getItem(`paramsAndRecs-${this.settingsHolder.tool.id}`)
            .then(paramsAndRecs => {
              const toolParamsAndRecs = decompress(paramsAndRecs);
              this.findSelectedParamsAndRecs(toolParamsAndRecs);
            })
            .catch(() => {
              // We haven't fetched this map mode value yet so need to get it
              this.getAndCahceParametersAndRecommendations();
            });
        }
      }
    });

    setTimeout(() => {
      if (this.isApp) {
        $('.scroll-content').css({
          width: '100%'
        });
      }
      this.onResize();
    });
  }

  private findSelectedParamsAndRecs = toolParamsAndRecs => {
    const selectedMaterialKey = this.settingsHolder.material.materialKey;
    const hra = this.settingsHolder.hardness.userHra
      ? this.settingsHolder.hardness.userHra
      : this.settingsHolder.hardness.hra;
    const operationKey = this.settingsHolder.hasStrategyOption
      ? this.settingsHolder.currentStrategy.operationKey
      : this.settingsHolder.currenttoolpath.operationKey;
    const selectedParamsAndRecs = toolParamsAndRecs.find(
      pt =>
        pt.materialKey === selectedMaterialKey &&
        pt.operationKey === operationKey &&
        pt.operationHardnessMin < hra &&
        hra < pt.operationHardnessMax &&
        pt.parameterHardnessMin < hra &&
        hra < pt.parameterHardnessMax &&
        pt.sfmHardnessMin < hra &&
        hra < pt.sfmHardnessMax
    );
    if (!!selectedParamsAndRecs) {
      this.settingsHolder.displayParamsAndRecs = true;
      this.settingsHolder.mapModeTwoValues = selectedParamsAndRecs;
      const updateList = !this.utils.isApp()
        ? ['parameters', 'recommendations']
        : ['parameters', 'recommendations', 'summary'];
      this.notifyChild(updateList, false);
    } else {
      this.displayMissingParamsAndRecsMessage();
    }
  };

  public indexChanged = $event => {
    if (this.tabHolder) {
      if ($event === 0) {
        $(this.tabHolder.nativeElement)
          .find('.mat-tab-header')
          .removeClass('showTabs');
      } else {
        $(this.tabHolder.nativeElement)
          .find('.mat-tab-header')
          .addClass('showTabs');
      }

      $(this.tabHolder.nativeElement)
        .find('.mat-tab-header')
        .height(this.windowsDimensions['tabMenuHeight']);
      this.selectedIndex = $event; // update the index
      $(this.tabHolder.nativeElement)
        .find('.mat-tab-label')
        .hide();
      if (this.selectedIndex === 5 || this.selectedIndex === 6) {
        this.sumarraySelected = false;
        this.iputSpecs = false;
        $(this.tabHolder.nativeElement)
          .find('.mat-tab-labels')
          .css({
            width: '70%',
            margin: '0 auto'
          });
        $(this.tabHolder.nativeElement)
          .find('.mat-tab-label')
          .eq(5)
          .show();
        $(this.tabHolder.nativeElement)
          .find('.mat-tab-label')
          .eq(6)
          .show();
      } else if (this.selectedIndex > 0 && this.selectedIndex < 5) {
        this.sumarraySelected = false;
        this.iputSpecs = true;
        $(this.tabHolder.nativeElement)
          .find('.mat-tab-labels')
          .css({
            width: '90%',
            margin: '0 auto'
          });
        $(this.tabHolder.nativeElement)
          .find('.mat-tab-label')
          .eq(1)
          .show();
        $(this.tabHolder.nativeElement)
          .find('.mat-tab-label')
          .eq(2)
          .show();
        $(this.tabHolder.nativeElement)
          .find('.mat-tab-label')
          .eq(3)
          .show();
        $(this.tabHolder.nativeElement)
          .find('.mat-tab-label')
          .eq(4)
          .show();
      } else if (this.selectedIndex === 7) {
        this.sumarraySelected = true;
        this.iputSpecs = false;
      }

      if (this.selectedIndex === 1) {
        $(this.tabHolder.nativeElement)
          .find('.mat-tab-header-pagination-before')
          .hide();
      } else if (this.selectedIndex > 1 && this.selectedIndex < 6) {
        $(this.tabHolder.nativeElement)
          .find('.mat-tab-header-pagination-before')
          .show();
        $(this.tabHolder.nativeElement)
          .find('.mat-tab-header-pagination-after')
          .show();
      } else if (this.selectedIndex === 6) {
        $(this.tabHolder.nativeElement)
          .find('.mat-tab-header-pagination-after')
          .hide();
      }
    }
  };

  public onSwipeLeft = () => {
    if (this.selectedIndex >= 1 && this.selectedIndex <= 5) {
      this.selectedIndex += 1;
    }
  };

  public onSwipeRight = () => {
    if (this.selectedIndex >= 2 && this.selectedIndex <= 6) {
      this.selectedIndex -= 1;
    }
  };

  /*--------- mobile class setup ----------*/

  public changeGroupButtons = ($event: MouseEvent, groupIndex: number) => {
    if (this.tabHolder) {
      $(this.tabHolder.nativeElement)
        .find('.mat-tab-label')
        .hide();
      $('.groupButton').removeClass('selected');

      if (groupIndex === 5) {
        this.sumarraySelected = false;
        this.iputSpecs = false;
        this.selectedIndex = 5;
        $('.groupButton').removeClass('selected');
        $('#outPut').addClass('selected');
        $(this.tabHolder.nativeElement)
          .find('.mat-tab-label')
          .eq(5)
          .show();
        $(this.tabHolder.nativeElement)
          .find('.mat-tab-label')
          .eq(6)
          .show();
      }

      if (groupIndex === 0) {
        this.sumarraySelected = false;
        this.iputSpecs = true;
        this.selectedIndex = 0;
        $('.groupButton').removeClass('selected');
        $('#inputSpec').addClass('selected');
      }

      if (groupIndex === 7) {
        this.sumarraySelected = true;
        this.iputSpecs = false;
        this.selectedIndex = 7;
        $('.groupButton').removeClass('selected');
        $('#summary').addClass('selected');
      }
    }
  };

  private startClicked = (event: any) => {
    this.selectedIndex = event;
  };

  public setInnerCardClass = (): string => {
    if (this.isApp) {
      if (this.selectedIndex == 0) {
        return 'innerCard startTab';
      }
      return 'innerCard toolTab';
    }
    return 'innerCard';
  };

  public setTabholder = (): string => {
    if (this.isApp) {
      if (this.tabHolder) {
        if (this.selectedIndex == 0) {
          $('ion-header').hide();
          $(this.tabHolder.nativeElement)
            .find('.mat-tab-body-wrapper')
            .css('background-color', 'rgba(255,255,255,0)');
          setTimeout(() => {
            $(this.tabHolder.nativeElement)
              .find('mat-tab-header')
              .hide();
          });

          return 'tabholder startTabholder';
        } else {
          $(this.tabHolder.nativeElement)
            .find('mat-tab-header')
            .show();
        }
        $('ion-header').show();
        $(this.tabHolder.nativeElement)
          .find('.mat-tab-body-wrapper')
          .css('background-color', 'rgba(255,255,255,1)');
        return 'tabholder toolTabholder';
      }
    }
    return 'tabholder';
  };

  public setOuterCardClass = (): string => {
    if (this.isApp) {
      if (this.selectedIndex == 0) {
        return 'outtercard appcard';
      }
      return 'outtercard appcard';
    }
    return 'outtercard';
  };

  public apptentiveMessageCenter = () => {
    if (this.isApp) {
      this.utils.openApptentiveMessageCenter();
    }
  };

  activateDeepLink() {
    this.deeplinks
      .routeWithNavController(this.navCtrl, {
        '/tool/:brand/:sku': {}
      })
      .subscribe(
        match => {
          // match.$route - the route we matched, which is the matched entry from the arguments to route()
          // match.$args - the args passed in the link
          // match.$link - the full link data

          // .$args is always undefined and a bug for the deeplink library
          // For now use split to get the :sku to pass in since we only need the sku on MAP
          const args = match.$link.fragment.split('/');
          this.endmillParams = {
            sku: args[3],
            brand: args[2]
          };
          let matTab = _.find(this.tabs, { label: 'Tool' });
          matTab.input = this.endmillParams;
          this.searchingForTool = true;
        },
        nomatch => {
          // nomatch.$link - the full link data
          // Will fire on desktop because cordova isn't on desktop. Deeplinks plugin handles the error with a console log so let the plugin handle it for now.
        }
      );
  }
  /*---------------------------------------*/

  private resetAll = () => {
    if (
      this.settingsHolder.tool &&
      this.settingsHolder.currenttoolpath &&
      (this.settingsHolder.hasStrategyOption ? !!this.settingsHolder.currentStrategy : true) &&
      this.settingsHolder.hardness &&
      this.settingsHolder.material &&
      this.settingsHolder.machine &&
      this.settingsHolder.machine.holderAdjustment &&
      this.settingsHolder.machine.spindleAdjustment
    ) {
      // Since the function is in tool.ts we can just call the function
      this.logUserData('reset');
    }

    this.selectedIndex = 0;
    $('.groupButton').removeClass('selected');
    $('#inputSpec').addClass('selected');
    this.settingsHolder = new ToolContainer();
    this.settingsHolder.machine = {
      spindle: 'CV40',
      holder: '',
      maxRPM: null,
      maxIPM: null,
      fixtureBar: 100,
      holderAdjustment: [],
      spindleAdjustment: []
    };
    this.settingsHolder.mapMode = 1;

    this.commonService.notifyOther({
      option: 'reset',
      value: this.settingsHolder
    }); // resetting all, all will listen for a "RESET"
    this.sumarraySelected = false;
    this.iputSpecs = true;
    this.maxIPM = null;
    this.maxRPM = null;
  };

  private notifyChild = (
    doNotNotify: Array<string>,
    emit: boolean = true,
    origin: string = undefined,
    updateToolPath: boolean = false
  ) => {
    let workHoldingChange = false;
    let maxRPMIPMChange = false;
    let insideCornerValueChange = false;

    // notify ONLY if the this.settingsHolder and the NEWholder is different, else no need to update, might cut down some notifications
    let settingsHolderTemp = _.clone(this.settingsHolder);
    delete settingsHolderTemp.machine.dirty;
    delete settingsHolderTemp.parameters;

    let oldSettingsHolderTemp = _.clone(this.oldSettingsHolder);
    if (oldSettingsHolderTemp.machine) {
      delete oldSettingsHolderTemp.machine.dirty;
      delete oldSettingsHolderTemp.parameters;
    }

    let differ = !_.isEmpty(this.utils.difference(settingsHolderTemp, oldSettingsHolderTemp));

    if (differ) {
      if (origin === 'machine') {
        if (this.workHolding !== this.settingsHolder.machine.fixtureBar) {
          this.workHolding = this.settingsHolder.machine.fixtureBar;
          workHoldingChange = true;
        }

        if (this.maxRPM !== this.settingsHolder.machine.maxRPM) {
          this.maxRPM = this.settingsHolder.machine.maxRPM;
          maxRPMIPMChange = true;
        }

        if (this.maxIPM !== this.settingsHolder.machine.maxIPM) {
          this.maxIPM = this.settingsHolder.machine.maxIPM;
          maxRPMIPMChange = true;
        }
      }
      if (origin === 'recommendations') {
        if (
          this.settingsHolder.recommendationForm &&
          this.insideCornerValue !==
            this.settingsHolder.recommendationForm.get('type1').get('insideCornerRadiusOfWall').value
        ) {
          this.insideCornerValue = this.settingsHolder.recommendationForm
            .get('type1')
            .get('insideCornerRadiusOfWall').value;
          insideCornerValueChange = true;
        }
      }
    }

    if (!workHoldingChange && !maxRPMIPMChange && origin === 'machine') {
      origin = undefined;
    }

    for (let i = 0; i < doNotNotify.length; i++) {
      //if its truly different, lets update oldSettingsHolder
      this.commonService.notifyOther({
        option: doNotNotify[i],
        value: this.settingsHolder,
        emit: emit,
        origin: origin,
        updateToolPath: updateToolPath,
        warningAlerts: differ,
        workHoldingChange: workHoldingChange,
        maxRPMIPMChange: maxRPMIPMChange,
        insideCornerValueChange: insideCornerValueChange
      }); // had to use a common sevice to trigger a change event in child, the onChange doesn't get triggered all the time and is not reliable
    }
    if (differ) {
      this.oldSettingsHolder = _.clone(this.settingsHolder); // ONLY update if there IS an actual change
    }
  };

  private updateHolder = (data: any, type: string, origin: string) => {
    // the data is the portion that is being updated
    // type is WHAT is being updated
    // we will cast the data according to the type that is sent in
    // update ONLY the appropiate portion of the holder if it needs to update
    // once Holder is updated, THEN let the children know to update EXCEPT for where it is coming from

    // check if edp data is changed
    let changedFlag = false;
    let updatingToolPath = false;
    let updateList = _.filter(this.children, child => {
      return child !== origin;
    }); //don't notify self
    let innerOrigin = undefined;
    switch (type) {
      case 'cutter':
        this.newHolder.tool = <Cutter_>data;
        if (!_.isEqual(this.newHolder.tool, this.settingsHolder.tool)) {
          //update
          this.settingsHolder.tool = this.newHolder.tool;
          changedFlag = true;
          this.toolpop = {
            tool: true,
            machine: this.settingsHolder.machine ? true : false,
            operations: this.settingsHolder.currenttoolpath ? true : false,
            material: this.settingsHolder.material ? true : false
          };
          if (this.settingsHolder.tool.materialIds && this.settingsHolder.material) {
            if (!this.settingsHolder.tool.materialIds.find(id => id === this.settingsHolder.material.id)) {
              //not in list)
              // its not in list, so the Invalid will pop up
              changedFlag = false; // so it won't update globally
              // the options will do the resets
              updateList = ['operation', 'machine', 'parameters', 'recommendations'];
              this.notifyChild(updateList, false);
            }
          }
        }
        break;

      case 'currentOpertaionType':
        this.settingsHolder.selectedOperation = data;
        break;

      case 'currenttoolpath':
        this.newHolder.currenttoolpath = data;
        if (!_.isEqual(this.newHolder.currenttoolpath, this.settingsHolder.currenttoolpath)) {
          //update
          this.toolpop = {
            tool: this.settingsHolder.tool ? true : false,
            machine: this.settingsHolder.machine ? true : false,
            operations: true,
            material: this.settingsHolder.material ? true : false
          };
          if (this.newHolder.currenttoolpath !== undefined) {
            this.settingsHolder.currenttoolpath = this.newHolder.currenttoolpath;
          }
          if (this.settingsHolder.currenttoolpath.hasOwnProperty('operationToolPathTitle')) {
            switch (this.settingsHolder.currenttoolpath.operationToolPathTitle.toLowerCase()) {
              case 'helical plunge':
                this.settingsHolder.parametersFields = 1;
                this.settingsHolder.recommendationFields = 4;
                break;
              case 'chamfering':
                this.settingsHolder.parametersFields = 2;
                this.settingsHolder.recommendationFields = 0;
                break;
              case '3d surfacing':
                this.settingsHolder.parametersFields = 3;
                this.settingsHolder.recommendationFields = 0;
                break;
              case 'trochoidal slotting':
                this.settingsHolder.parametersFields = 0;
                this.settingsHolder.recommendationFields = 2;
                break;
              case 'full slotting':
                this.settingsHolder.parametersFields = 0;
                this.settingsHolder.recommendationFields = 0;
                break;
              case 'traditional roughing':
                this.settingsHolder.parametersFields = 0;
                this.settingsHolder.recommendationFields = 0;
                break;
              default:
                this.settingsHolder.parametersFields = 0;
                this.settingsHolder.recommendationFields = 1;
                break;
            }
          } else {
            switch (this.settingsHolder.currenttoolpath.operationName.toLowerCase()) {
              case 'helical plunge':
                this.settingsHolder.parametersFields = 1;
                this.settingsHolder.recommendationFields = 4;
                break;
              case 'chamfering':
                this.settingsHolder.parametersFields = 2;
                this.settingsHolder.recommendationFields = 0;
                break;
              case '3d surfacing':
                this.settingsHolder.parametersFields = 3;
                this.settingsHolder.recommendationFields = 0;
                break;
              case 'trochoidal slotting':
                this.settingsHolder.parametersFields = 0;
                this.settingsHolder.recommendationFields = 2;
                break;
              case 'full slotting':
                this.settingsHolder.parametersFields = 0;
                this.settingsHolder.recommendationFields = 0;
                break;
              case 'traditional roughing':
                this.settingsHolder.parametersFields = 0;
                this.settingsHolder.recommendationFields = 0;
                break;
              default:
                this.settingsHolder.parametersFields = 0;
                this.settingsHolder.recommendationFields = 1;
                break;
            }
          }

          this.settingsHolder.mapMode = data.mapMode;
          this.settingsHolder.hasStrategyOption = !!data.strategies && data.strategies.length > 0;
          changedFlag = true;
          if (this.settingsHolder.tool && this.settingsHolder.tool.materialIds && this.settingsHolder.material) {
            if (
              !this.settingsHolder.tool.materialIds.find(id => id === this.settingsHolder.material.id) ||
              this.settingsHolder.hasStrategyOption
            ) {
              // materials aren't in the list so user will se popup and the options will be able to reset
              // or the tool path has strategy options that will handle notifying when selected
              // so it won't update globally in either case
              changedFlag = false;
              updateList = ['machine', 'parameters', 'recommendations'];
              this.notifyChild(updateList, false);
            }
          }
        }
        break;

      case 'currentStrategy':
        // If there is no data being passed in then we are just clearing out the strategy
        // Tool path will has already set map mode so no need to change it
        if (data) {
          this.settingsHolder.currentStrategy = data;
          this.settingsHolder.mapMode = data.mapMode;
        } else {
          this.settingsHolder.currentStrategy = null;
        }
        changedFlag = true;
        if (this.settingsHolder.tool && this.settingsHolder.tool.materialIds && this.settingsHolder.material) {
          if (!this.settingsHolder.tool.materialIds.find(id => id === this.settingsHolder.material.id)) {
            // materials aren't in the list so user will se popup and the options will be able to reset
            // so it won't update globally
            changedFlag = false;
            updateList = ['machine', 'parameters', 'recommendations'];
            this.notifyChild(updateList, false);
          }
        }
        break;

      case 'hardness':
        this.newHolder.hardness = <Hardness>data;
        if (!_.isEqual(this.newHolder.hardness, this.settingsHolder.hardness)) {
          //update
          this.settingsHolder.hardness = _.clone(this.newHolder.hardness);
          changedFlag = true;
        }
        break;

      case 'material':
        this.newHolder.material = <Material_>data;
        if (!_.isEqual(this.newHolder.material, this.settingsHolder.material)) {
          this.toolpop = {
            tool: this.settingsHolder.tool ? true : false,
            machine: this.settingsHolder.machine ? true : false,
            operations: this.settingsHolder.currenttoolpath ? true : false,
            material: true
          };
          //update
          this.settingsHolder.material = _.clone(this.newHolder.material);
          changedFlag = true;

          // Only check after the materials are set
          this.commonService.notifyOther({
            option: 'checkToGetParamsAndRecs'
          });
        }
        break;

      case 'parameters':
        this.newHolder.parameters = <Parameters_>data.data;

        let originalOrigin = data.origin;
        if (!_.isEqual(this.newHolder.parameters, this.settingsHolder.parameters)) {
          //if there is a Originalorigin, then don't update that Originalorigin
          //obviously don't update itself, but update the rest

          if (originalOrigin) {
            updateList = ['tool', 'material', 'operation'];
            this.notifyChild(updateList, false);
            changedFlag = false;
          } else {
            //update
            this.settingsHolder.parameters = _.clone(this.newHolder.parameters);
            updateList = ['tool', 'material', 'operation', 'recommendations'];
            this.notifyChild(updateList, false);
            changedFlag = false;
          }
        }
        break;

      case 'machine':
        this.newHolder.machine = <Machine_>data;
        if (!_.isEqual(this.newHolder.machine, this.settingsHolder.machine)) {
          this.toolpop = {
            tool: this.settingsHolder.tool ? true : false,
            machine: true,
            operations: this.settingsHolder.currenttoolpath ? true : false,
            material: this.settingsHolder.material ? true : false
          };

          // update
          // check if its the defaults, if not then update dirty
          let defaultMachine = new Machine_();

          if (!_.isEqual(this.settingsHolder.machine, defaultMachine) && !this.settingsHolder.machine.dirty) {
            this.newHolder.machine.dirty = true;
          }
          this.settingsHolder.machine = _.clone(this.newHolder.machine);
          innerOrigin = 'machine';
          changedFlag = true;
          updateList = ['start', 'tool', 'parameters', 'recommendations', 'summary'];
        }
        break;

      case 'recommendations':
        this.newHolder.recommendation = <Recommendation_>data.data.recommendation;
        this.newHolder.recommendationForm = <FormGroup>data.data.recommendationForm;

        // need to update Parameters BUT tell Parameters NOT to update recommendation
        // recommendation doesn't need to tell everyone else, we can but it will be unnecessary notification, just parameters should be good enough
        if (
          !_.isEqual(this.newHolder.recommendation, this.settingsHolder.recommendation) ||
          !_.isEqual(this.newHolder.recommendationForm, this.settingsHolder.recommendationForm)
        ) {
          this.settingsHolder.recommendation = _.clone(this.newHolder.recommendation);
          this.settingsHolder.recommendationForm = _.clone(this.newHolder.recommendationForm);
          this.notifyChild(['parameters'], false);
          changedFlag = false;
        }
        break;

      case 'parameterChangeWithSpecificChild':
        this.newHolder.parameters = <Parameters_>data.data;
        if (!_.isEqual(this.newHolder.parameters, this.settingsHolder.parameters)) {
          this.settingsHolder.parameters = _.clone(this.newHolder.parameters);
          updateList = [data.specificChild];
          this.notifyChild(updateList, false);
          changedFlag = false;
        }
        break;

      case 'recommendationChangeWithChild':
        this.newHolder.recommendation = <Recommendation_>data.data.recommendation;
        this.newHolder.recommendationForm = <FormGroup>data.data.recommendationForm;

        let origin = data.origin ? data.origin : undefined;
        //need to update Parameters BUT tell Parameters NOT to update recommendation
        if (
          !_.isEqual(this.newHolder.recommendation, this.settingsHolder.recommendation) ||
          !_.isEqual(this.newHolder.recommendationForm, this.settingsHolder.recommendationForm)
        ) {
          this.settingsHolder.recommendation = _.clone(this.newHolder.recommendation);
          this.settingsHolder.recommendationForm = _.clone(this.newHolder.recommendationForm);
          let doNotupdateList = ['parameters'];
          this.notifyChild(doNotupdateList, false, origin);
          changedFlag = false;
        }
        break;

      case 'aggressiveWarning':
        //JUST notifying tool to highlight, NOT data change at all
        this.commonService.notifyOther({
          option: 'aggressiveWarning',
          value: this.settingsHolder
        }); // resetting Tool
        changedFlag = false;
        break;
    }

    if (this.isApp) {
      if (this.toolpop.machine && this.toolpop.material && this.toolpop.operations && this.toolpop.tool) {
        let holder = this.settingsHolder.machine.holder ? this.settingsHolder.machine.holder : undefined;
        if (holder) {
          $('.infoSnackBar').slideDown('1000', () => {
            setTimeout(() => {
              $('.infoSnackBar').slideUp();
              this.toolpop = {
                machine: false,
                material: false,
                tool: false,
                operations: false
              };
            }, 5000);
          });
        }
      }

      if (
        this.settingsHolder.tool &&
        this.settingsHolder.currenttoolpath &&
        this.settingsHolder.hardness &&
        this.settingsHolder.material &&
        this.settingsHolder.machine &&
        this.settingsHolder.machine.dirty
      ) {
        this.settingsHolder.dirty = true;
      } else {
        this.settingsHolder.dirty = false;
      }
    }

    if (changedFlag) {
      this.notifyChild(updateList, undefined, innerOrigin, updatingToolPath);
    }

    innerOrigin = undefined;
  };

  getAndCahceParametersAndRecommendations = async () => {
    const productKey = this.settingsHolder.tool.id;
    const parsAndRecs: ParametersAndRecommendations[] = await this.toolProvider.getParametersAndRecommendationsForEndmill(
      productKey
    );

    if (parsAndRecs) {
      this.findSelectedParamsAndRecs(parsAndRecs);
      this.cache.saveItem(`paramsAndRecs-${productKey}`, compress(parsAndRecs), 'paramsAndRecs');
    } else if (this.settingsHolder.mapMode === 2) {
      this.displayMissingParamsAndRecsMessage();
    }
  };

  private displayMissingParamsAndRecsMessage = () => {
    this.settingsHolder.displayParamsAndRecs = false;
    let message: Message = {
      title: 'An Unexpected Error',
      message:
        'An unexpected error has occurred. Please contact the support team at <a href="mailto:webapps@harveyperformance.com">webapps@harveyperformance.com</a> or call (855)-828-2106'
    };
    this.utils.openDialog(message, 'confirm', () => {});
  };

  goToStartOver = () => {
    let self = this;
    $('.infoSnackBar').slideUp('fast', () => {
      self.resetAll();
      self.selectedIndex = 0;
    });
  };

  goToSummary = () => {
    let self = this;
    $('.infoSnackBar').slideUp('fast', () => {
      self.selectedIndex = 5;
    });
  };

  toggleMenu = () => {
    if (!this.mobileMenuOpened) {
      $('.sideMenuContainer').animate({ left: '0%' }, '1000', () => {
        this.mobileMenuOpened = true;
        $('.sideMenuSibling').click(event => {
          event.preventDefault();
          event.stopPropagation();
          this.closeMenu();
        });
      });
    } else {
      this.closeMenu();
    }
  };

  closeMenu = () => {
    if (this.mobileMenuOpened) {
      $('.sideMenuContainer').animate({ left: '-100%' });
      this.mobileMenuOpened = false;
    }
  };
}

class tabsContent {
  constructor(public label: string, public content?: any, public output?: object, public input?: object) {
    this.label = label;
    this.content = content;
    this.output = output;
    this.input = input;
  }
}
